export default {
  apiurl: 'https://lr-vingaker.se/wp/wp-json/wp/v2/'
}



// WEBPACK FOOTER //
// ./src/store/config.js